/*eslint-disable no-unused-vars */
/*eslint-disable no-use-before-define */
import React from 'react';
import { ConfigurationSVG } from '../../img/GlobalSVG';
import './warning.scss';

const WarningComponent = ({ onlyMemberPortal = false }) => {
  return (
    <div className="warning-parent">
      <div>
        <ConfigurationSVG.WarningSVG />
      </div>
      <div className="warning-content">
        <span className="content-bold">Warning:</span>
        {onlyMemberPortal ? (
          <span>
            {' '}
            These settings will have a significant impact on the behavior and
            functionality of the Member portal. Please proceed with caution and
            make sure to thoroughly test any changes before implementing them on
            a live site.
          </span>
        ) : (
          <span>
            {' '}
            These settings will have a significant impact on the behavior and
            functionality of both the Member portal and the Admin portal. Please
            proceed with caution and make sure to thoroughly test any changes
            before implementing them on a live site.
          </span>
        )}
      </div>
    </div>
  );
};

export default WarningComponent;
